import { Outlet, useNavigate, useParams } from 'react-router';

import { Main } from 'src/components/Layout';
import { Tabs, TabsList, TabsTrigger } from 'src/components/ui/tabs';

import { settingsTabs } from '../model';

const SettingsLayout = () => {
  const navigate = useNavigate();
  const { '*': path = '' } = useParams();

  const onValueChange = (value: string) => navigate(`/settings/${value}`);

  return (
    <Main
      title="Settings"
      headerChildren={
        <Tabs value={path} onValueChange={onValueChange} className="p-6 pb-0">
          <TabsList className="justify-start p-0 h-9 md:h-12 bg-white">
            {settingsTabs.map(({ value, label }) => (
              <TabsTrigger
                value={value}
                key={value}
                className="rounded-none border-b-2 border-transparent data-[state=active]:border-foreground data-[state=active]:shadow-none h-full px-3 transition-all duration-300 font-semibold"
              >
                {label}
              </TabsTrigger>
            ))}
          </TabsList>
        </Tabs>
      }
      className="bg-background-secondary"
    >
      <Outlet />
    </Main>
  );
};

export default SettingsLayout;
